// convert BT-PCS01 to bt_pcs_01
export const formatKey = (item) => {
  // lowercase and replace - with _
  let key = item.toLowerCase().replace(/-/g, "_");

  // separate prefix and trailing digits
  const match = key.match(/^([a-z_]+)(\d+)$/);

  if (match) {
    const prefix = match[1]; // "pv_pcs" or "bt_pcs"
    const number = match[2]; // "01", "10", etc.
    return `${prefix}_${number}`; // add underscore before number
  }

  return key; // fallback
};

// export const reverseFormatKey = (item) => {
//   const match = item.match(/^([a-z_]+)_(\d+)$/);

//   if (match) {
//     let prefix = match[1]; // "pv_pcs" or "bt_pcs"
//     const number = match[2]; // "01", "02", etc.

//     // replace underscores with hyphens and uppercase
//     prefix = prefix.replace(/_/g, "-").toUpperCase();

//     return `${prefix}${number}`;
//   }

//   // fallback if pattern doesn't match
//   return item.replace(/_/g, "-").toUpperCase();
// };

// utils/formatKey.js
export const reverseFormatKey = (item) => {
  // Remove whitespace, lowercase, replace - with _
  let key = item.trim().toLowerCase().replace(/-/g, "_");

  // Ensure underscore before number: PV-PCS01 -> pv_pcs_01
  const match = key.match(/^([a-z_]+)(\d+)$/);
  if (match) {
    const prefix = match[1];
    const number = match[2].padStart(2, "0"); // always 2 digits
    return `${prefix}_${number}`;
  }
  return key;
};

